import { memo } from 'react'
import { CheckIcon, XMarkIcon } from '@heroicons/react/24/outline'
import GlassmorphButton from '../../ui/GlassmorphButton'
import { labelClasses, baseInputClasses } from '../../../styles/inputStyles'

/**
 * DeleteAccountForm - Account deletion confirmation form
 * Requires user to type "DELETE" to confirm
 */
const DeleteAccountForm = memo(function DeleteAccountForm({
  confirmText,
  isDeleting,
  onConfirmChange,
  onSubmit,
  onCancel,
  t
}) {
  return (
    <div className="mt-4 p-3 bg-red-50/70 backdrop-blur-sm rounded-md border border-red-200/50">
      <form onSubmit={onSubmit} className="space-y-3">
        <div className="text-xs text-red-800 mb-2">
          <p className="font-semibold mb-1">{t('profile.deleteWarning', 'Warning: This action cannot be undone!')}</p>
          <p>{t('profile.deleteExplanation', 'All your data, sightings, and favorites will be permanently deleted.')}</p>
        </div>

        <div>
          <label htmlFor="deleteConfirm" className={labelClasses}>
            {t('profile.typeDeleteToConfirm', 'Type DELETE to confirm')}
          </label>
          <input
            type="text"
            id="deleteConfirm"
            value={confirmText}
            onChange={(e) => onConfirmChange(e.target.value)}
            className={`${baseInputClasses} border-red-300 focus:ring-red-500`}
            placeholder="DELETE"
            required
            autoComplete="off"
          />
        </div>

        <div className="flex gap-2 pt-2">
          <GlassmorphButton
            type="submit"
            variant="danger"
            icon={CheckIcon}
            disabled={isDeleting || confirmText !== 'DELETE'}
            size="sm"
            className="flex-1 px-3 py-2 text-xs font-medium"
          >
            {isDeleting ? t('common.deleting', 'Deleting...') : t('profile.confirmDelete', 'Delete Account')}
          </GlassmorphButton>
          <GlassmorphButton
            type="button"
            variant="secondary"
            icon={XMarkIcon}
            onClick={onCancel}
            disabled={isDeleting}
            size="sm"
            className="flex-1 px-3 py-2 text-xs font-medium"
          >
            {t('common.cancel', 'Cancel')}
          </GlassmorphButton>
        </div>
      </form>
    </div>
  )
})

export default DeleteAccountForm
